<template>
  <WorkPackageSubPageModule
    :workpackage="workpackage"
    :isMobile="isMobile"
    :location="location"
    :loading="loading"
    :background_color="workpackage_bg_hex"
    :foreground_color="workpackage_fg_hex"
    header_icon="pencil"
    :header_text_short="$t('WorkpackageRework.Info.Log.Header')"
    :header_text_long="$t('WorkpackageRework.Info.Log.Header').toUpperCase() + '.' + $t('WorkpackageRework.Info.Log.List')"
    @headerBack="$router.push({name: `${location}WorkPackageInfo`, params: { nav_back: $route.params.nav_back} })"
  >
    <template #header-rightside>
      <v-btn
        :class="show_filter ? workpackage.textcolor : ''"
        :color="show_filter ? workpackage_bg_hex : workpackage_fg_hex"
        icon
        @click="show_filter = !show_filter"
      >
        <TIcon name="filter" :color="show_filter ? workpackage_bg_hex : workpackage_fg_hex"/>
      </v-btn>
      <v-btn
        icon
        :color="workpackage_fg_hex"
        @click="$router.push({
          name: `${location}WorkPackageLogListDetails`,
          params: {
            content_id: 'create',
            nav_back: $route.params.nav_back,
          }
        })"
        >
        <TIcon name="sign-plus"/>
      </v-btn>
    </template>
    <template #header-below>
      <DropDown
        v-if="show_filter"
        placeholder="Filter"
        :items="['created', 'updated', 'deleted', 'added', 'removed', 'comment']"
        :value="$store.state.WorkPackageLogList.log_list_filter_new"
        :clearable="true"
        :max_width="1000"
        :light="is_light_mode(workpackage_fg_hex)"
        :background_color="workpackage_bg_hex"
        :foreground_color="workpackage_fg_hex"
        @selected="setLogListFilterNew($event?$event:false), !$event?show_filter=false:''"
        style="z-index: 120;"
      />
    </template>
    <template #body>
      <div
        v-for="(log, index) in getWorkPackageLogListNew"
        :key="log.id"
        style="width: 100%"
      >
        <ClickableListItem
          :has_lines="true"
          :full_line="true"
          :is_first="index === 0"
          :is_unclickable="true"
          :margin="6"
          :background_color="workpackage_bg_hex"
          :foreground_color="workpackage_fg_hex"
        >
        <!-- @emittedClick="test()" -->
          <template #front>
            <TTooltip value="Copy to clipboard">
              <TIcon :color="workpackage_fg_hex" style="cursor: pointer;" :name="getIconByAction(log.action)" @click.native="copyComment(log)" />
            </TTooltip>
          </template>
          <template #descriptor>
            <div class="work-package-loglist-content">
              <TText
                :text="`${log.user}`"
                small
                :color="workpackage_fg_hex"
                align="left"
              />
              <TText
                :text="`${getLocalDate(log.created)}`"
                :size="9"
                :color="workpackage_fg_hex"
                align="left"
              />
              <TText
                :text="getLogText(log)"
                :color="workpackage_fg_hex"
                :size="11"
                :font_weight="400"
                align="left"
                :strikethrough="log.crossed_out"
              />
            </div>
          </template>
          <template #info>
            <button
              v-if="(log.action == 'comment' || log.action == 'created comment') && log.user === getUser.first_name + ' ' + getUser.last_name"
              class="work-package-loglist-strikethrough"
              :style="`background-color: ${log.crossed_out ? `${getTranspHexColor(workpackage_fg_hex, .25)}` : ''};`"
              v-ripple
              @click.prevent.stop="toggleCrossedOut(log)"
            >
              <TIcon name="strike-through-active"/>
            </button>
          </template>
        </ClickableListItem>
      </div>
    </template>
  </WorkPackageSubPageModule>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import { TColor } from '@/mixins/TColor.mixin.js'
  import { WorkPackageReworkMixin } from '@/mixins/WorkPackageRework.mixin.js'

  import WorkPackageSubPageModule from '@/modules/WorkPackageWIP/WorkPackageSubPageModule.module.vue';
  import DropDown from '@/components/WorkPackageWIP/DropDown.component.vue';
  import ClickableListItem from '@/components/WorkPackageWIP/ClickableListItem.component.vue';
  import TText from '@/components/Taktify/TText.component.vue';
  import TIcon from '@/components/Taktify/TIcon.component.vue';


  export default {
    props: ['location', 'backlog', 'prefix', ],
    mixins: [
      TColor,
      WorkPackageReworkMixin
    ],

    components: {
      WorkPackageSubPageModule,
      DropDown,
      ClickableListItem,
      TText,
      TIcon,
    },

    data: () => ({
    }),

    created() {
      this.loadData();
    },

    watch: {
      workpackage_id() {
        this.loadData();
      },
    },

    computed: {
      ...mapGetters('Ultra', [
        'getUObjects'
      ]),
      ...mapGetters('View', [
        'getLocalDate'
      ]),
      ...mapGetters('WorkPackageLogList', [
        'getWorkPackageLogListNew',
      ]),
      ...mapGetters('Auth', [
        'getUser'
      ]),
    },

    methods: {
      ...mapActions('Ultra', [
        'createUObject',
        'updateUObject',
        'deleteUObject',
        'updateUObjectPosition',
      ]),
      ...mapActions('WorkPackageLogList', [
        'setLogListFilterNew',
        'updateLoglistEntry'
      ]),
      // getLocalDate(datestring){
      //   const date = new Date(datestring);
      //   return `${date.toISOString().split('T')[0]} ${date.toTimeString().split(' ')[0]}`;
      // },
      loadData() {
        this.loading = true;
        this.$store.dispatch('WorkPackageLogList/requestWorkPackageLogList', {
          project_id: this.project_id,
          train_id: this.train_id,
          taktarea_id: this.taktarea_id,
          twaggon_id: this.twaggon_id,
          wbgroup_id: this.wbgroup_id,
          wbline_id: this.wbline_id,
          workpackage_id: this.workpackage_id,
          backlog: this.backlog,
        })
        .then(() => {
          this.loading = false;
        });
      },
      copyComment(log){
        let text = log.value;
        if (!log.action.includes('comment')) {
          text = `${log.target} ${log.action}${log.value ? ': ' + log.value : ''}`;
        }
        navigator.clipboard.writeText(text);
      },
      getIconByAction(action) {
        switch (action) {
          case 'created':
            return 'sign-plus';
          case 'updated':
            return 'wrench-large';
          case 'comment':
            return 'speech-bubble';
          case 'created comment':
            return 'speech-bubble';
          case 'deleted':
            return 'bin-delete';
          case 'added':
            return 'file-add';
          case 'removed':
            return 'file-remove';
          default:
            return 'exclamation-circle';
        }
      },

      getLogText(log) {
        if(log.action != 'comment' && log.action != 'created comment') {
          // EXAMPLE: Work Package created
          // EXAMPLE: Work Package created: <Name>
          return `${log.target} ${log.action}${log.value ? ': ' + log.value : ''}`;
        }
        else {
          // NOTE: there should never be a comment without a value (without text)
          return `Comment: ${log.value}`;
        }
      },

      toggleCrossedOut(entry){
        this.updateLoglistEntry({
          project_id: this.project_id,
          train_id: this.train_id,
          taktarea_id: this.taktarea_id,
          twaggon_id: this.twaggon_id,
          wbgroup_id: this.wbgroup_id,
          wbline_id: this.wbline_id,
          workpackage_id: this.workpackage_id,
          backlog: this.backlog,
          entry_id: entry.id,
          update: {
            crossed_out: !entry.crossed_out
          }
        });
        },
    },
  }
</script>

<style>
  .work-package-loglist-content {
    padding-right: 8px;
  }
  .work-package-loglist-strikethrough > .ticon-component {
    position: absolute;
  }
  .work-package-loglist-strikethrough {
    padding: 8px;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 16px;
    transition: background-color 0.5s ease-in-out;
    position: relative;
  }
</style>
